export default "__VITE_ASSET__FFkelx4$__"